import { TExchangesAvailable } from '@/core/constants'
import { ExchangeHistoryItemInterface } from '@/redux/transactions/transactions.types'
import { ByBitTransactionHistory } from '@/services/bybit'
import { TSheetItem } from '@/ui/kit/Modals/InteractiveModal/InteractiveModalParts'
import { getBybitHistoryKeysTranslations } from '../HistoryTrade.translations/bybitHistoryDictionaries'
import { Statement } from '@/services/tigerx'
import { TUsdmIncomeHistory } from '@tigertrade/binance-ts'
import { getBinanceHistoryKeysTranslations } from '../HistoryTrade.translations/binanceHistoryDictionary'
import { getTigerXHistoryKeysModalTranslations } from '../HistoryTrade.translations/tigerXHistoryDictionary'

export const formatHistoryItemForModalOutput = (
  bill: ExchangeHistoryItemInterface,
  exchangeType: TExchangesAvailable
): TSheetItem[] => {
  switch (exchangeType) {
    case 'BINANCE_BROKER_FUTURE':
      const translations = getBinanceHistoryKeysTranslations()
      return Object.entries(bill).reduce((acc, [key, value]) => {
        return [
          ...acc,
          {
            title: translations[key as keyof TUsdmIncomeHistory] || key,
            value: value,
          },
        ]
      }, [] as TSheetItem[])
    case 'BYBIT_BROKER':
      const translationsBybit = getBybitHistoryKeysTranslations()
      return Object.entries(bill).reduce((acc, [key, value]) => {
        return [
          ...acc,
          {
            title: translationsBybit[key as keyof ByBitTransactionHistory] || key,
            value: value,
          },
        ]
      }, [] as TSheetItem[])
    case 'TIGER_X':
      const translationsTigerX = getTigerXHistoryKeysModalTranslations()
      return Object.entries(bill).reduce((acc, [key, value]) => {
        if (translationsTigerX[key as keyof Statement] !== undefined) {
          return [
            ...acc,
            {
              title: (translationsTigerX as any)[key],
              value: value,
            },
          ]
        }
        return acc
      }, [] as TSheetItem[])

    default:
      return []
  }
}
